import React from 'react';
import SpinnerComponent from '../../../../molecules/SpinnerComponent';
import s from './loadingComponent.module.scss';
var Loading = function Loading(_ref) {
  var loading = _ref.loading;
  return loading && /*#__PURE__*/React.createElement("div", {
    className: "flex-center full-width full-height ".concat(s.loader)
  }, /*#__PURE__*/React.createElement(SpinnerComponent, null));
};
export default Loading;